module.exports = __webpack_public_path__ + "static/img/aboutus.528e170c.png";